import VirtualList from './virtual-list.vue';

export default VirtualList;



// WEBPACK FOOTER //
// ./src/components/virtual-list/index.js